module.exports = __webpack_public_path__ + "images/smartphone-screen-3_b994904fdf6505ab391120bcbf12b6e1.png";